var observer;

function awaitSpecialPanel(mutations) {
    let special = document.querySelector("#special");
    if (special === null) {
        return;
    }

    observer.disconnect();
    fixPanel();
}

function fixPanel() {
    const special = document.querySelector("#special");
    if (special === null) {
        return;
    }

    const quit = special.querySelector(".special-quit");
    if (quit === null) {
        return;
    }

    const medQuit = document.createElement("a");

    medQuit.innerHTML = quit.innerHTML;
    quit.innerHTML = "";

    // @note я надеюсь, что ссылка не поменяется и все будет ок))
    medQuit.setAttribute("href", "/themes/standart-version")
    medQuit.setAttribute("style", "padding: 0px; font-size: 0px !important; text-decoration: none; display: block;")

    quit.appendChild(medQuit);
}

export default function specialPanelFix() {
    // @note пришлось немного помудрить с ожиданием панели, ибо она грузится несколько иначе
    observer = new MutationObserver(awaitSpecialPanel);
    observer.observe(document, {childList: true, subtree: true})
}